import { useEffect, useState } from "react";

// In-memory laboratory store: survives moving between instruments for the whole browser session.
const listeners = new Set();
export const labStore = {
  live: {},
  saved: [],
  save(entry) { this.saved.unshift({ ...entry, key: `${entry.instrument}-${Date.now()}`, at: new Date() }); listeners.forEach((f) => f()); },
  remove(key) { this.saved = this.saved.filter((e) => e.key !== key); listeners.forEach((f) => f()); },
};
export function useSaved(instrument) {
  const [, force] = useState(0);
  useEffect(() => { const f = () => force((n) => n + 1); listeners.add(f); return () => listeners.delete(f); }, []);
  return instrument ? labStore.saved.filter((e) => e.instrument === instrument) : labStore.saved;
}
export const download = (url, name) => { const a = document.createElement("a"); a.href = url; a.download = name; a.click(); };
export const downloadJSON = (data, name) => {
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 1)], { type: "application/json" }));
  download(url, name); setTimeout(() => URL.revokeObjectURL(url), 2000);
};
